module.exports = __webpack_public_path__ + "static/FaktPro-Light-21be8bf6dee5a2db4da348139797e7f6.ttf";